export function saveExecutorForm(emit, payload) {
  return new Promise((resolve) => {
    emit('updateExecutor', {
      ...payload,
      onSaved: resolve,
    })
  })
}
